import { createApp, App } from 'vue'
import LoadingComponent from './LoadingComponent.vue'
import type { LoadingOptions } from './types'

class LoadingService {
    private app: App | null = null
    private instance: any = null

    private init() {
        if (!this.instance) {
            // 创建一个容器元素
            const container = document.createElement('div')
            document.body.appendChild(container)

            // 创建 Vue 应用实例
            this.app = createApp(LoadingComponent)
            this.instance = this.app.mount(container)
        }
    }

    /**
     * 显示loading
     */
    show(options: LoadingOptions): string {
        this.init()
        return this.instance.show(options)
    }

    /**
     * 隐藏loading
     */
    hide(): void {
        if (this.instance) {
            this.instance.hide()
        }
    }

    /**
     * 显示带文本的loading
     */
    loading(text?: string, options?: Partial<LoadingOptions>): string {
        return this.show({
            text,
            ...options
        })
    }

    /**
     * 显示自定义动画的loading
     */
    custom(animationData: any, text?: string, options?: Partial<LoadingOptions>): string {
        return this.show({
            animationData,
            text,
            ...options
        })
    }

    /**
     * 显示小尺寸loading
     */
    small(text?: string, options?: Partial<LoadingOptions>): string {
        return this.show({
            text,
            size: 60,
            ...options
        })
    }

    /**
     * 显示大尺寸loading
     */
    large(text?: string, options?: Partial<LoadingOptions>): string {
        return this.show({
            text,
            size: 120,
            ...options
        })
    }

    /**
     * 销毁服务
     */
    destroy(): void {
        if (this.app && this.instance) {
            this.app.unmount()
            this.app = null
            this.instance = null
        }
    }
}

// 创建单例实例
const loading = new LoadingService()

export default loading

// 导出类型
export type { LoadingOptions }
